<template>
  <div class="seed">
    <breadcrumb class="bread" :path="path" :name="name" :childPath="childPath" :childName="childName" :childPathThree="childPathThree"
                :childNameThree="childNameThree"></breadcrumb>
    <div class="main-row contain">
      <div class="col col-xlg-12 col-lg-12 col-md-12 col-sm-12 seed-item">
        <div class="searchStyle">
          <el-form :inline="true" :model="searchForm" label-position="top">
            <!--
            <el-form-item label="种拉丁名" prop="growLatin">
              <el-input clearable v-model="searchForm.growLatin" placeholder="种拉丁名"></el-input>
            </el-form-item>
            <el-form-item label="种中文名" prop="growChinese">
              <el-input clearable v-model="searchForm.growChinese" placeholder="种中文名"></el-input>
            </el-form-item>
            <el-form-item label="采集年份" prop="collectTimeList">
              <el-date-picker
                  type="years" value-format="yyyy"
                  v-model="searchForm.collectTimeList"
                  placeholder="选择一个或多个年">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="采集地点" prop="collectAdd">
              <el-cascader @clear="clear" ref="collectAdd" v-model="searchForm.collectAdd" :options="areaSelectData"
                           clearable placeholder="请选择你所在的城市" @change="handleChange">
              </el-cascader>
            </el-form-item>
            <el-form-item label="资源类型" prop="resourceTypeList">
              <el-select @change="changeHandle" multiple  v-model="searchForm.resourceTypeList" clearable placeholder="请选择资源类型">
                <el-option
                    v-for="(item,i) in this.resourceTypeListOp"
                    :key="i"
                    :label="item"
                    :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="送样单位" prop="sampleUnit">
              <el-select v-model="searchForm.sampleUnit" clearable placeholder="请选择送样单位">
                <el-option
                    v-for="(sa, k) in sampleUnitListOp"
                    :key="k"
                    :label="sa"
                    :value="sa">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="专题负责人" prop="specialLeader">
              <el-select v-model="searchForm.specialLeader" clearable placeholder="请选择专题负责人">
                <el-option
                    v-for="(s, index) in specialLeaderListOp"
                    :key="index"
                    :label="s"
                    :value="s">
                </el-option>
              </el-select>
            </el-form-item>
            -->
            <el-form-item label="资源类型" prop="resourceTypeList">
              <el-select multiple v-model="searchForm.resourceTypeList" clearable placeholder="请选择">
                <el-option v-for="item in resourceTypeListOp" :key="item.id" :label="item.label" :value="item.itemValue"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="采集年份" prop="collectYear">
<!--              <el-select v-model="searchForm.collectYear" placeholder="请选择采集年份">-->
<!--                <el-option v-for="item in collectYearListOp" :key="item" :label="item" :value="item">-->
<!--                </el-option>-->
<!--              </el-select>-->
              <el-date-picker  type="year" @change="changePick" style="width: 100%" v-model="searchForm.collectYear" placeholder="选择采集年份"></el-date-picker>
            </el-form-item>
            <el-form-item label="省" prop="province">
              <el-select v-model="searchForm.province" placeholder="请选择省份">
                <el-option v-for="item in provinceListOp" :key="item.id" :label="item.itemValue" :value="item.itemValue">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="地区" prop="area">
              <el-select v-model="searchForm.area" placeholder="请选择地区">
                <el-option v-for="item in areaListOp" :key="item.id" :label="item.itemValue" :value="item.itemValue">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="区/县" prop="district">
              <el-select v-model="searchForm.district" placeholder="请选择区/县">
                <el-option v-for="item in districtListOp" :key="item.id" :label="item.itemValue" :value="item.itemValue">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="单位" prop="sampleUnit">
              <el-select v-model="searchForm.sampleUnit" clearable placeholder="请选择单位">
                <el-option v-for="item in sampleUnitListOp" :key="item.id" :label="item.label" :value="item.itemValue"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="专题负责人" prop="specialLeader">
              <el-select v-model="searchForm.specialLeader" clearable placeholder="请选择专题负责人">
                <el-option v-for="item in specialLeaderListOp" :key="item.id" :label="item.label" :value="item.itemValue"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="物种查询" prop="speciesQuery">
              <el-input clearable v-model="searchForm.speciesQuery" placeholder="中文名或学名"></el-input>
            </el-form-item>
            <el-form-item label="采集号" prop="collectNumber">
              <el-input clearable v-model="searchForm.collectNumber" placeholder="采集号"></el-input>
            </el-form-item>
            <div style="" class="button">
              <el-button type="primary"  @click="onSubmit">查询</el-button>
              <el-button type="primary"  @click="backSubmit">返回</el-button>
            </div>
          </el-form>
          <div style="text-align: center;font-size: 15px;margin-bottom: 10px;color: #59A6E8">说明: 1. “种子-转历史”: 种子为全空瘪/不成熟/顽拗型种子等情况，详见备注；2. “仅标本”: 仅提交了标本，无其他种质材料。</div>

        </div>
        <template >
          <el-table class="table"
              :data="tableData" border
              :header-cell-style="{backgroundColor: '#eee',color: '#333'}" :row-style="{height: '8px'}"
                    :cell-style="{padding:'0px'}">
            <el-table-column fixed type="index" header-align="center" align="left" label="ID" width="80">
              <template slot-scope="scope">
                <span>{{ (page - 1) * pageSize + scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="sectionChinese" header-align="center" align="left" label="科中文名" width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="sectionLatin" header-align="center" align="left" label="科拉丁名" width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="growChinese" header-align="center" align="left" label="中文名" width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="growLatin" header-align="center" align="left" label="学名" width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="resourceType" header-align="center" align="left" label="资源类型" show-overflow-tooltip ></el-table-column>
            <el-table-column prop="collectNumber" header-align="center" align="left" label="采集号" width="120" show-overflow-tooltip ></el-table-column>
            <el-table-column prop="collectUser" header-align="center" align="left" label="采集人" min-width="160px" show-overflow-tooltip></el-table-column>
            <el-table-column prop="collectYear" header-align="center" align="left" label="采集年份" width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="province" header-align="center" align="left" label="省" show-overflow-tooltip></el-table-column>
            <el-table-column prop="area" header-align="center" align="left" label="地区" show-overflow-tooltip></el-table-column>
            <el-table-column prop="district" header-align="center" align="left" label="区/县" show-overflow-tooltip></el-table-column>
            <el-table-column prop="sampleUnit" header-align="center" align="left" label="单位" width="240" show-overflow-tooltip></el-table-column>
            <el-table-column prop="specialLeader" header-align="center" align="left" label="专题负责人" width="110" show-overflow-tooltip></el-table-column>
            <el-table-column prop="note" header-align="center" align="left" label="备注" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" header-align="center" align="left" fixed="right" width="120">
              <template slot-scope="scope">
                <el-button type="text" @click="toTableDetail(scope.row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination class="pagin" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="page" :page-size="pageSize"
                         :page-sizes="[25,50,75,100]" layout="total, sizes, prev, pager, next" :total="totalPage"></el-pagination>
        </template>
<!--        <el-empty description="没有找到数据" style="width: 20%;margin: 0 auto" v-else></el-empty>-->
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import { regionData, CodeToText, TextToCode} from 'element-china-area-data'
import { fetchList, getSeedNewResourceType } from '@/network/germplasmAnimal/index'
import breadcrumb from '@/components/breadcrumb'
export default {
  name: "seed",
  components: { breadcrumb },
  data() {
    return {
    path: '',
    name: '',
      childName:'',
      childPath:'',
      childPathThree: '',
      childNameThree: '',
      page: 1,
      pageSize: 25,
      totalPage: 0,
      tableData: [],
      type: 'seeds',
      searchForm: {

      },
      areaSelectData: regionData,
      resourceTypeListOp:[],
      sampleUnitListOp:[],
      specialLeaderListOp:[],//专题负责人
      collectYearListOp: [], //采集年份
      districtListOp: [], //区县
      areaListOp: [], //地区
      provinceListOp: [], //省份
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.path = from.path
      vm.name = '资源'
    })
  },
  mounted() {
    this.getList()
    getSeedNewResourceType().then(res => {
      // console.log(res)
      this.resourceTypeListOp = res.data.data.resourceTypeList
      this.sampleUnitListOp = res.data.data.sampleUnitList
      this.specialLeaderListOp = res.data.data.specialLeaderList
      this.collectYearListOp = res.data.data.collectYearList
      this.districtListOp = res.data.data.districtList
      this.areaListOp = res.data.data.areaList
      this.provinceListOp = res.data.data.provinceList
    })
  },

  created() {
    this.childName = '种质资源';
    this.childPath = this.$route.path
    // console.log(this.$route)
    this.childPathThree=this.$route.path
    this.childNameThree = this.$route.name
  },
  methods: {
    changePick(val){
      let a = new Date(val)
      let year = a.getFullYear() + ''
      this.searchForm.collectYear = year
      // console.log(this.searchForm)
      return  this.searchForm.collectYear
    },
    changeHandle(val) {
      this.searchForm.resourceTypeList =  val
    },
    clear() {
      this.$refs.collectAdd.checkedValue = ''
      this.searchForm.collectAddress = ''
    },
    handleChange(val) {
      // if(val) {
      //   let provinceCode = CodeToText[val[0]]
      //   let cityCode = CodeToText[val[1]]
      //   let origin = CodeToText[val[2]]
      //   this.searchForm.collectAddress = provinceCode + '/' + cityCode + '/' + origin
      // }
      if(val.length === 0) {
        this.$refs.collectAdd.getCheckedNodes()
        this.searchForm.colloctAdd = []
        this.searchForm.collectAddress = ''
      } else if(val.length > 0) {
        let provinceCode = CodeToText[val[0]]
        let cityCode = CodeToText[val[1]]
        let origin = CodeToText[val[2]]
        this.searchForm.collectAddress = provinceCode + '/' + cityCode + '/' + origin
      }
    },
    getList() {
      fetchList(Object.assign({
        page: this.page,
        pageSize: this.pageSize,
      },this.searchForm)).then(response => {
        // console.log(response)
        // if(response.data.data.length > 0){
          this.tableData = response.data.data.seedNewList
          this.totalPage = response.data.data.total
        // }

      })
    },
    handleSizeChange(val){
      this.pageSize = val
      this.page = 1
      this.getList()

    },
    handleCurrentChange(val){
      this.page = val
      this.getList()
    },
    openDetail(id){
      this.$router.push({
        path: '/detail',
        params: {
          id: id,
          infoContent: this.infoContent
        },
        // query: {
        //   infoContent: this.infoContent
        // }
      })
      getObj(id).then(res => {
        // console.log(res.data.data)
        this.infoContent = res.data.data
      })
      // window.open('http://192.168.0.116:8887/information?id='+id,'_blank')
    },
    toTableDetail(row) {
      this.$router.push({
        path: '/tableDetail',
        query: {
          id: row.id,
          formName: this.type,
          name: '植物种质'
        }
      })
    },
    onSubmit() {
      this.page = 1
      this.getList()
    },
    backSubmit() {
      this.page = 1
      this.searchForm = {}
      this.getList()
    },
  }
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/seeds";
::v-deep .el-pagination {
  padding: 20px 5px !important;
  text-align: center;
}
</style>